import { useLesson } from '../lessons/lessonQueries';
import { usePlaylist } from '../savedItems/savedItemsQueries';
// XAVI TODO: Fix cyclic dependency properly
import { useShort } from '../shortContent/shortContentQueries';
import { useTrack } from '../tracks/tracksQueries';
export const useSocialShareData = ({
  id,
  type,
  language
}, skip) => {
  const {
    track,
    trackLoading
  } = useTrack(id, language, skip || type !== 'TRACK');
  const {
    lesson,
    lessonLoading
  } = useLesson(id, language, skip || type !== 'LESSON');
  const {
    playlist,
    playlistLoading
  } = usePlaylist(id, skip || !(type === 'PLAYLIST' || type === 'LEARNING_PATH'));
  const {
    short,
    shortLoading
  } = useShort(id, skip || type !== 'SHORT_FORM_CONTENT');
  let template = null;
  if (track) template = track.name;
  if (lesson) template = lesson.name;
  if (playlist) template = playlist.name;
  if (short) template = short.name;
  const loading = trackLoading || lessonLoading || playlistLoading || shortLoading;
  return {
    template,
    isShareable: lesson ? lesson.visibility !== 'IN_TRACK_ONLY' : true,
    loading
  };
};